/* PureVie Bio — animations GSAP + ScrollTrigger */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Ingrédients : scrollytelling façon Apple ----------
     La section est épinglée, la vidéo d'ouverture du flacon se scrubbe
     avec le scroll, et les légendes d'ingrédients apparaissent une à une
     selon leur fenêtre de progression (data-progress="début,fin"). */
  function initScrolly() {
    var scrolly = document.querySelector('[data-scrolly]');
    if (!scrolly) return;
    var video = scrolly.querySelector('[data-scrub-video]');
    var captions = Array.prototype.map.call(
      scrolly.querySelectorAll('.scrolly__caption'),
      function (el) {
        var range = (el.dataset.progress || '0,1').split(',');
        return { el: el, start: parseFloat(range[0]), end: parseFloat(range[1]) };
      }
    );

    // Fallback : pas d'épinglage, vidéo en lecture simple, cartes recap visibles
    if (reduced || typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      scrolly.classList.add('scrolly--static');
      if (video) {
        var fallback = video.dataset.fallbackSrc;
        if (fallback) video.src = fallback;
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries, obs) {
            if (entries[0].isIntersecting) {
              video.play().catch(function () {});
              obs.disconnect();
            }
          }, { threshold: 0.4 }).observe(scrolly);
        }
      }
      return;
    }

    // Mobile : bascule sur la vidéo portrait 9:16 (plein écran, rien de coupé)
    var isMobile = window.matchMedia('(max-width: 899px)').matches;
    if (video && isMobile && video.dataset.srcPortrait) {
      video.src = video.dataset.srcPortrait;
      if (video.dataset.posterPortrait) video.poster = video.dataset.posterPortrait;
      scrolly.classList.add('scrolly--portrait');
    }
    if (video) video.load();

    var target = 0;
    var current = 0;
    var raf = null;
    function tick() {
      current += (target - current) * 0.18;
      if (video && video.duration) video.currentTime = current;
      if (Math.abs(target - current) > 0.01) {
        raf = requestAnimationFrame(tick);
      } else {
        raf = null;
      }
    }

    var veil = scrolly.querySelector('[data-scrolly-veil]');
    var callouts = Array.prototype.slice.call(scrolly.querySelectorAll('.callout'));

    function caption(progress) {
      // Fondu plus court en proportion = plateau visible plus long au centre
      var FADE = 0.035;
      captions.forEach(function (c) {
        var o = 0;
        var y = 24;
        if (progress >= c.start && progress <= c.end) {
          var inEdge = Math.min(1, (progress - c.start) / FADE);
          var outEdge = Math.min(1, (c.end - progress) / FADE);
          o = Math.min(inEdge, outEdge);
          y = 24 * (1 - o);
        }
        c.el.style.opacity = o;
        var base = c.el.classList.contains('scrolly__caption--center') ||
                   (window.innerWidth < 900 && !c.el.classList.contains('scrolly__caption--center'))
          ? 'translate(-50%,' + y + 'px)'
          : 'translateY(' + (y - 50) + '%) translateY(' + y + 'px)';
        c.el.style.transform = base;
      });
    }

    // Finale : léger voile (lisibilité) puis les callouts fléchés
    // apparaissent un à un et RESTENT affichés jusqu'à la fin du pin.
    function finale(progress) {
      if (veil) {
        veil.style.opacity = 0.35 * Math.max(0, Math.min(1, (progress - 0.74) / 0.08));
      }
      callouts.forEach(function (el, i) {
        var start = 0.78 + i * 0.035;
        var o = Math.max(0, Math.min(1, (progress - start) / 0.05));
        el.style.opacity = o;
        el.style.transform = 'translateY(' + 14 * (1 - o) + 'px)';
      });
    }

    ScrollTrigger.create({
      trigger: scrolly,
      start: 'top top',
      end: '+=560%',
      pin: true,
      scrub: true,
      anticipatePin: 1,
      invalidateOnRefresh: true,
      onUpdate: function (self) {
        if (video && video.duration) {
          // La vidéo se joue sur les 74 premiers % du pin, puis reste sur la frame finale
          target = Math.min(1, self.progress / 0.74) * video.duration;
          if (!raf) raf = requestAnimationFrame(tick);
        }
        caption(self.progress);
        finale(self.progress);
      }
    });

    // Les positions du pin sont recalculées quand la mise en page bouge :
    // polices web, images, métadonnées vidéo — sinon la scène se décale
    // (vide noir au-dessus, callouts déplacés en fin de scroll).
    if (video) {
      video.addEventListener('loadedmetadata', function () { ScrollTrigger.refresh(); });
    }
    window.addEventListener('load', function () { ScrollTrigger.refresh(); });
  }

  /* ---------- Révélations au scroll ---------- */
  function initReveals() {
    if (reduced || typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    gsap.registerPlugin(ScrollTrigger);

    // Sections : fondu + glissement vers le haut
    document.querySelectorAll('.anim').forEach(function (el) {
      gsap.fromTo(el,
        { opacity: 0, y: 28 },
        {
          opacity: 1, y: 0, duration: 0.8, ease: 'power2.out',
          scrollTrigger: { trigger: el, start: 'top 88%', once: true }
        }
      );
    });

    // Badges bénéfices : un par un, de gauche à droite
    document.querySelectorAll('.benefit-pills').forEach(function (group) {
      gsap.fromTo(group.children,
        { opacity: 0, x: -16 },
        {
          opacity: 1, x: 0, duration: 0.5, stagger: 0.12, ease: 'power2.out',
          scrollTrigger: { trigger: group, start: 'top 90%', once: true }
        }
      );
    });

    // Étapes de la timeline : révélation progressive
    var timeline = document.querySelector('[data-timeline]');
    if (timeline) {
      gsap.fromTo(timeline.querySelectorAll('.timeline__step'),
        { opacity: 0, y: 32 },
        {
          opacity: 1, y: 0, duration: 0.7, stagger: 0.25, ease: 'power2.out',
          scrollTrigger: { trigger: timeline, start: 'top 80%', once: true }
        }
      );
    }

    // Lignes du tableau comparatif : une par une
    var compare = document.querySelector('[data-compare]');
    if (compare) {
      gsap.fromTo(compare.querySelectorAll('tbody tr'),
        { opacity: 0, x: -24 },
        {
          opacity: 1, x: 0, duration: 0.5, stagger: 0.15, ease: 'power2.out',
          scrollTrigger: { trigger: compare, start: 'top 85%', once: true }
        }
      );
    }
  }

  function init() {
    initReveals();
    initScrolly();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
